<mat-stepper (selectionChange)="onStepChange($event)" style="border-radius:5px" [linear]="false">
  <mat-step>
    <ng-template matStepLabel>Order Confirmation</ng-template>
    <div style="display:flex; flex-direction:column; align-items:center">
      <h2>Please confirm the following information is correct and enter your name to proceed.</h2>
      <fieldset class="rms-fieldset" style="width:50%; margin-bottom: 20px">
        <legend>Receive Data</legend>
        <div style="width: 98%; background-color:transparent">
          <rms-input label="Ref#" [ngModel]="InventoryItem.InventoryID" [disabled]="true"></rms-input>
          <rms-input label="PO#" [ngModel]="InventoryItem.PurchaseOrderID" [disabled]="true"></rms-input>
          <rms-input label="Coffee" [ngModel]="InventoryItem.InventoryTypeName" [disabled]="true"></rms-input>
          <rms-input label="Marks" [ngModel]="InventoryItem.Marks" [disabled]="true"></rms-input>
          <rms-input label="Bags Expected" [ngModel]="InventoryItem.BagsOrdered" [disabled]="true"></rms-input>
          <rms-input label="Container#" [ngModel]="InventoryItem.ContainerNumber" [disabled]="true"></rms-input>
          <rms-input label="Seal#" [ngModel]="InventoryItem.SealNumber" [disabled]="true"></rms-input>
        </div>
      </fieldset>
      <div>
        <button class="btn-bg-red" (click)="closeTallyCreator.emit()">Cancel</button>
        <button matButton class="btn-bg-green" matStepperNext>Confirm</button>
      </div>
    </div>
  </mat-step>
  <mat-step [stepControl]="palletFormGroup">
    <ng-template matStepLabel>Pallet Weights</ng-template>
    <form [formGroup]="palletFormGroup">
      <div style="height:76vh;" class="form-flow">
        <div class="fields">
          <fieldset class="rms-fieldset" style="width: auto; height:68vh">
            <legend>Pallets</legend>

            <div formArrayName="pallets" class="fields" style="display:flex; flex-direction:column; height:68vh; width: auto">

              <div *ngFor="let group of pallets.controls; let i = index" [formGroupName]="i">
                <div style="display:flex; gap: 20px; align-items: center">
                  <!-- Weight with Pallet -->
                  <rms-input style="width:150px"
                             label="Weight"
                             type="decimal"
                             formControlName="WeightWithPallet"
                             [required]="true">
                  </rms-input>

                  <!-- # of Bags -->
                  <rms-input style="width:150px"
                             label="Bags"
                             type="decimal"
                             formControlName="Bags"
                             [required]="true">
                  </rms-input>

                  <!-- Remove row -->
                  <button mat-mini-fab type="button" aria-label="Remove row" (click)="removePallet(i)">
                    <mat-icon>remove</mat-icon>
                  </button>
                </div>

                <!-- Row-level validation messages (optional) -->
                <div class="x-sm-font text-red" *ngIf="group.invalid && (group.dirty || group.touched)">
                  <span *ngIf="group.get('WeightWithPallet')?.errors?.['required']">Weight is required.</span>
                  <span *ngIf="group.get('WeightWithPallet')?.errors?.['notNumber']">Weight must be a number.</span>
                  <span *ngIf="group.get('WeightWithPallet')?.errors?.['min']">Weight cannot be negative.</span>

                  <span *ngIf="group.get('Bags')?.errors?.['required']"># of Bags is required.</span>
                  <span *ngIf="group.get('Bags')?.errors?.['notInteger']"># of Bags must be an integer.</span>
                  <span *ngIf="group.get('Bags')?.errors?.['min']"># of Bags cannot be negative.</span>
                </div>
              </div>
            </div>

            <!-- Add row -->
            <div style="margin-top:10px; display:flex; align-items:center; gap:10px">
              <button mat-mini-fab type="button" (click)="addPallet()" [disabled]="!canAddMore()" aria-label="Add row">
                <mat-icon>add</mat-icon>
              </button>
              <span class="sm-font">{{ pallets.length }} / {{ MAX_PALLETS }}</span>
              <span class="x-sm-font text-red" *ngIf="pallets.errors?.['maxItems']">
                Max {{ MAX_PALLETS }} pallets reached.
              </span>
              <span class="x-sm-font text-red" *ngIf="pallets.errors?.['minItems']">
                At least one pallet is required.
              </span>
            </div>
          </fieldset>

          <fieldset class="rms-fieldset">
            <legend>Slack or Damaged Bags</legend>

            <!-- SLACKS ARRAY -->
            <div formArrayName="slacks" style="display:flex; flex-direction:column; gap:10px">

              <!-- Rows -->
              <div *ngFor="let group of slacks.controls; let i = index" [formGroupName]="i">
                <div style="display:flex; gap: 20px; align-items: center">
                  <!-- Gross Weight Of Bag -->
                  <rms-input style="width:150px"
                             label="Gross Weight Of Bag"
                             type="decimal"
                             formControlName="GrossWeight"
                             [required]="true">
                  </rms-input>

                  <!-- # of Bags -->
                  <rms-input style="width:150px"
                             label="# of Bags"
                             type="decimal"
                             formControlName="Bags"
                             [required]="true">
                  </rms-input>

                  <!-- Remove row -->
                  <button mat-mini-fab type="button" aria-label="Remove slack row" (click)="removeSlack(i)">
                    <mat-icon>remove</mat-icon>
                  </button>
                </div>

                <!-- Row-level validation messages -->
                <div class="x-sm-font text-red" *ngIf="group.invalid && (group.dirty || group.touched)">
                  <span *ngIf="group.get('grossWeightOfBag')?.errors?.['required']">Gross weight is required.</span>
                  <span *ngIf="group.get('grossWeightOfBag')?.errors?.['notNumber']">Gross weight must be a number.</span>
                  <span *ngIf="group.get('grossWeightOfBag')?.errors?.['min']">Gross weight cannot be negative.</span>

                  <span *ngIf="group.get('bagsCount')?.errors?.['required']"># of Bags is required.</span>
                  <span *ngIf="group.get('bagsCount')?.errors?.['notInteger']"># of Bags must be an integer.</span>
                  <span *ngIf="group.get('bagsCount')?.errors?.['min']"># of Bags cannot be negative.</span>
                </div>
              </div>
            </div>

            <!-- Add row / counter / messages -->
            <div style="margin-top:10px; display:flex; align-items:center; gap:10px">
              <button mat-mini-fab type="button" (click)="addSlack()" [disabled]="!canAddMoreSlacks()" aria-label="Add slack row">
                <mat-icon>add</mat-icon>
              </button>
              <span class="sm-font">{{ slacks.length }} / 6</span>
              <span class="x-sm-font text-red" *ngIf="slacks.errors?.['maxItems']">
                Max 6 slack rows reached.
              </span>
              <!-- Note: minItems(0) allows zero slacks; no message needed -->
            </div>
          </fieldset>
          <rms-input type="decimal" label="Pallet Weight" formControlName="palletWeight" [required]="true"></rms-input>
        </div>
      </div>
    </form>
    <div>
      <button class="btn-bg-red" (click)="closeTallyCreator.emit()">Cancel</button>
      <button matButton class="btn-bg-red" matStepperPrevious>Back</button>
      <button matButton class="btn-bg-green" matStepperNext [disabled]="!palletFormGroup.valid">Next</button>
    </div>
  </mat-step>

  <mat-step [stepControl]="unloadingFormGroup">
    <ng-template matStepLabel>Unloading Information</ng-template>

    <form [formGroup]="unloadingFormGroup">
      <div style="height:76vh;" class="form-flow">
        <div class="fields" style="align-content:center">
          <!-- TARE WEIGHTS (exactly 3, all required) -->
          <fieldset class="rms-fieldset">
            <legend>Tare Weights in oz/bag</legend>

            <div formArrayName="tareWeights" style="width:96%; display:flex; flex-direction:column; gap:10px">
              <div *ngFor="let fg of tareWeights.controls; let i = index" [formGroupName]="i">
                <div style="display:flex; gap:20px; align-items:center">
                  <rms-input style="width:140px"
                             label="Bag #"
                             type="decimal"
                             formControlName="BagNumber">
                  </rms-input>

                  <rms-input style="width:180px"
                             label="Tare (oz/bag)"
                             type="decimal"
                             formControlName="TareWeight"
                             [required]="true">
                  </rms-input>
                </div>

                <!-- Row-level errors -->
                <div class="x-sm-font text-red" *ngIf="fg.invalid && (fg.dirty || fg.touched)">
                  <span *ngIf="fg.get('BagNumber')?.errors?.['required']">Bag # is required.</span>
                  <span *ngIf="fg.get('BagNumber')?.errors?.['notInteger']">Bag # must be an integer.</span>
                  <span *ngIf="fg.get('BagNumber')?.errors?.['min']">Bag # must be at least 1.</span>

                  <span *ngIf="fg.get('TareWeight')?.errors?.['required']">Tare is required.</span>
                  <span *ngIf="fg.get('TareWeight')?.errors?.['notNumber']">Tare must be a number.</span>
                  <span *ngIf="fg.get('TareWeight')?.errors?.['min']">Tare cannot be negative.</span>
                </div>
              </div>
            </div>
          </fieldset>

          <!-- Pallet Weight + Crew (optional fields) -->
          <rms-input label="HiLo Driver" formControlName="hiloDriver" [required]="true"></rms-input>
          <rms-input label="Helper #1" formControlName="helper1" [required]="true"></rms-input>
          <rms-input label="Helper #2" formControlName="helper2"></rms-input>
          <rms-input label="Stacking Driver" formControlName="stackingDriver" [required]="true"></rms-input>

          <!-- SPOT CHECK (show 6, require min 3 completed) -->
          <fieldset class="rms-fieldset">
            <legend>Spot Check</legend>

            <div formArrayName="spotChecks" style="width:96%; display:flex; flex-direction:column; gap:10px">
              <div *ngFor="let fg of spotChecks.controls; let i = index" [formGroupName]="i">
                <div style="display:flex; gap:20px; align-items:center">
                  <rms-input style="width:140px"
                             label="Bag #"
                             type="decimal"
                             formControlName="BagNumber">
                  </rms-input>

                  <rms-input style="width:180px"
                             label="Weight (lbs)"
                             type="decimal"
                             formControlName="TestWeight"
                             [required]="true">
                  </rms-input>
                </div>

                <!-- Row-level messages (not strictly required, but helpful to show invalid rows) -->
                <div class="x-sm-font text-red" *ngIf="fg.invalid && (fg.dirty || fg.touched)">
                  <span *ngIf="fg.get('BagNumber')?.errors?.['notInteger']">Bag # must be an integer.</span>
                  <span *ngIf="fg.get('BagNumber')?.errors?.['min']">Bag # must be at least 1.</span>

                  <span *ngIf="fg.get('TestWeight')?.errors?.['notNumber']">Weight must be a number.</span>
                  <span *ngIf="fg.get('TestWeight')?.errors?.['min']">Weight cannot be negative.</span>
                </div>
              </div>
            </div>

            <!-- Array-level requirement: need at least 3 completed rows -->
            <div class="x-sm-font text-red" *ngIf="spotChecks.errors?.['minCompleted']">
              Please enter at least {{ spotChecks.errors?.['minCompleted']?.min }} complete spot checks
              (Bag # and Weight).
              Current: {{ spotChecks.errors?.['minCompleted']?.actual }}.
            </div>
          </fieldset>
          <fieldset class="rms-fieldset">
            <legend>Condition Of Container</legend>

            <div formGroupName="condition" style="display:flex; flex-direction:column; gap:6px;">
              <rms-checkbox label="Condensation" formControlName="condensation"></rms-checkbox>
              <rms-checkbox label="Paper Lining" formControlName="paperLining"></rms-checkbox>
              <rms-checkbox label="Hole In Container" formControlName="holeInContainer"></rms-checkbox>
              <rms-checkbox label="Other" formControlName="other"></rms-checkbox>
            </div>
          </fieldset>
          <fieldset class="rms-fieldset">
            <legend>Insect Activity</legend>

            <div formGroupName="insects" style="display:flex; flex-direction:column; gap:6px;">
              <rms-checkbox label="Larvae" formControlName="larvae"></rms-checkbox>
              <rms-checkbox label="Beetles" formControlName="beetles"></rms-checkbox>
              <rms-checkbox label="Moths" formControlName="moths"></rms-checkbox>
              <rms-checkbox label="Other" formControlName="other"></rms-checkbox>
            </div>
          </fieldset>
          <rms-date label="Date Stripped" formControlName="DateStripped" [required]="true"></rms-date>
          <rms-input label="Location" formControlName="LocationNumber"></rms-input>
          <rms-textarea label="Comments" formControlName="Comments"></rms-textarea>
        </div>
      </div>
    </form>
    <div>
      <button class="btn-bg-red" (click)="closeTallyCreator.emit()">Cancel</button>
      <button class="btn-bg-red" matStepperPrevious>Back</button>
      <button class="btn-bg-green" matStepperNext [disabled]="!unloadingFormGroup.valid">Next</button>
    </div>
  </mat-step>

  <mat-step [completed]="confirmationReady">
    <ng-template matStepLabel>Confirmation</ng-template>

    <div *ngIf="tallyPreviewUrl; else generating">
      <h2>Tally Sheet Preview</h2>
      <iframe [src]="tallyPreviewUrl | safeUrl" width="100%" height="600px"></iframe>
      <button class="btn-bg-red" (click)="closeTallyCreator.emit()">Cancel</button>
      <button class="btn-bg-red" matStepperPrevious>Edit Tally</button>
      <button class="btn-bg-green" (click)="finish()" matStepperNext>Save Tally</button>
    </div>

    <ng-template #generating>
      <div style="display:flex; justify-content:center; width:100%; height: 72vh; align-items:center">
        <div style=" display: flex; flex-direction: column; align-items: center;">
          <h2>Generating Tally Sheet...</h2>
          <mat-spinner></mat-spinner>
        </div>
      </div>
    </ng-template>
  </mat-step>

  <mat-step [completed]="Uploaded">
    <ng-template matStepLabel>Done</ng-template>
    Tally has been saved to the system. Please click Finish to exit the Tally Creator.
    <button class="btn-bg-green" (click)="closeTallyCreator.emit()">Finish</button>
  </mat-step>
</mat-stepper>
